export var IRetailerLinkCohortEnum;
(function (IRetailerLinkCohortEnum) {
    let RetailerLinkCohort;
    (function (RetailerLinkCohort) {
        RetailerLinkCohort["RETAILER_LINK_COHORT_UNKNOWN"] = "RETAILER_LINK_COHORT_UNKNOWN";
        /**
         * Retailers who have never linked their POS or have churned after the new experience launched
         */
        RetailerLinkCohort["NEW"] = "NEW";
        /**
         * Retailers who unlinked their POS before the new experience launched
         */
        RetailerLinkCohort["CHURNED"] = "CHURNED";
        /**
         * Linked retailers who haven't linked items since the new experience launched
         */
        RetailerLinkCohort["INACTIVE"] = "INACTIVE";
        /**
         * Linked retailers who have linked items since the new experience launched
         */
        RetailerLinkCohort["ACTIVE"] = "ACTIVE";
    })(RetailerLinkCohort = IRetailerLinkCohortEnum.RetailerLinkCohort || (IRetailerLinkCohortEnum.RetailerLinkCohort = {}));
    /**
     * Return an instance of IRetailerLinkCohortEnum with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IRetailerLinkCohortEnum.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IRetailerLinkCohortEnum || (IRetailerLinkCohortEnum = {}));
